import bootswatch from 'webutils/bootswatch'

function BootswatchDirectiveFactory($parse) {
    return {
        scope: false,
        link: function ($scope, $elem, $attr) {
            $parse($attr.ngModel || $attr.bootswatch).assign($scope, bootswatch);
        }
    }
}

export default BootswatchDirectiveFactory;